import React from 'react';
import { AccountCardRow, Box, Spacer, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { avatarLogoBcp } from '@icons';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useSelectedAccount } from '@store';
import { CoreHelper, FormatHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { Company } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$types';

export const AccountSelectedPlaceholder: React.FC = () => {
	const colorCardIzibizi = '#5D92CD';
	const { palette } = useTheme();
	const t = useTranslation();
	const { selectedAccount } = useSelectedAccount();
	let formatNumber = '';
	if (!CoreHelper.isNullOrEmpty(selectedAccount?.account?.number)) {
		formatNumber = FormatHelper.formatAccountNumber(selectedAccount?.account?.number as string, Company.ab);
	}

	return (
		<>
			<Box styles={{ margin: rem(16, 0, 12) }}>
				<AccountCardRow
					mode="simplified"
					account={{
						name: selectedAccount?.companyName || '',
					}}
					headerTitle={t('placeholders.accountSelected.enterprise')}
					feedbackBar={{
						size: 'medium',
						container: {
							backgroundColor: colorCardIzibizi,
						},
					}}
				/>
				<Spacer horizontal={rem(16)} />
				<AccountCardRow
					mode="simplified"
					account={{
						name: selectedAccount?.account.name || '',
						number: formatNumber,
						avatar: {
							source: avatarLogoBcp,
						},
					}}
					headerTitle={t('placeholders.accountLinked')}
					feedbackBar={{
						size: 'medium',
						container: {
							backgroundColor: palette.primary.p1,
						},
					}}
				/>
			</Box>
		</>
	);
};
